import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=101b9e05&scoped=true&"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js&"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangePassword.vue?vue&type=style&index=0&id=101b9e05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b9e05",
  null
  
)

export default component.exports